export default {"src":"/_next/static/media/icon-play-circle.86a33328.svg","height":36,"width":36};